import styles from "./BildungsangeboteSection.module.css";
import { useNavigate } from "react-router-dom";
import { FaSchool, FaUniversity } from "react-icons/fa";
import { BiSolidSchool } from "react-icons/bi";
import { GrWorkshop } from "react-icons/gr";

const sections = [
  {
    title: "Grundschule",
    duration: "Klassen 1–4",
    link: "/bildungsangebote/igsgrundstufe",
    image: "./assets/bildungsangebotcatcher/GS-Grundstufe.PNG",
    icon: <FaSchool />,
  },
  {
    title: "Sekundarstufe I (Integrierte Gesamtschule)",
    duration: "Klassen 5–10",
    link: "/bildungsangebote/igssekundarstufe",
        image: "./assets/bildungsangebotcatcher/IGS-Sekundarstufe.PNG",
    icon: <BiSolidSchool />,
  },
{
    title: "Berufsfachschule",
    duration: "Klassen 10-11",
    link: "/bildungsangebote/berufsfachschule",
        image: "./assets/bildungsangebotcatcher/Berufsfachschule.PNG",
    icon: <GrWorkshop />,
  },
  {
    title: "Fachoberschule",
    duration: "Klassen 11–12",
    link: "/bildungsangebote/fachoberschule",
        image: "./assets/bildungsangebotcatcher/Fachoberschule.PNG",
    icon: <GrWorkshop />,
  },

  {
    title: "Höhere Berufsfachschule",
    duration: "2-jährig",
    link: "/bildungsangebote/hoehereberufsfachschule",
        image: "./assets/bildungsangebotcatcher/Hohereberufsfachschule.PNG",
    icon: <GrWorkshop />,
  },

    {
      title: "Gymnasiale Oberstufe",
      duration: "Klassen 11–13",
      link: "/bildungsangebote/oberstufe",
          image: "./assets/bildungsangebotcatcher/GymnasialeOberstufe.jpg",
      icon: <FaUniversity />,
    },
];

export default function BildungsangeboteSection() {
  const navigate = useNavigate();

  return (
    <section className={styles.section}>
      <div className={styles.header}>
        <span className={styles.label}>UNSER BILDUNGSANGEBOT</span>

        <h2>
          Für Ihr Bildungsweg.
          <br />
          Für Ihre Zukunft.
        </h2>
      </div>

      <div className={styles.cards}>
        {sections.map((item) => (
          <div
            key={item.title}
            className={styles.card}
            onClick={() => navigate(item.link)}
          >
            <div className={styles.imageWrapper}>
              <img src={item.image} alt={item.title} />

              <div className={styles.icon}>
                {item.icon}
              </div>
            </div>

            <div className={styles.cardContent}>
              <h3>{item.title}</h3>

              <span className={styles.duration}>
                {item.duration}
              </span>



            </div>
          </div>
        ))}
      </div>
    </section>
  );
}